import { render, staticRenderFns } from "./LapidusAccountView.vue?vue&type=template&id=17b84c79&"
import script from "./LapidusAccountView.vue?vue&type=script&lang=js&"
export * from "./LapidusAccountView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports